module.exports = __webpack_public_path__ + "img/case6.aa080410.jpg";